import React from "react";
import Header from "./components/Header.jsx";
import "./style.css"; 

function App() {
  return <div className="app">

    <Header />

  </div>;
}

export default App;
